<script lang="ts" setup>
import { UseIsLoading, UseIsLoadingTimeout } from "~/states/animation";

const isLoading = UseIsLoading();
const timeLoading = UseIsLoadingTimeout();
const loading = ref<boolean>(false);
let timeoutId: ReturnType<typeof setTimeout> | null = null;

watch(isLoading, (newVal) => {
  if (newVal) {
    timeoutId = setTimeout(() => {
      if (isLoading.value) {
        loading.value = true;
      }
    }, timeLoading.value);
  } else {
    loading.value = false;
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }
});
</script>
<template>
  <!-- Affichage du modal de chargement si loading est actif -->
  <span class="modal-container" :class="{ 'modal-active': loading }">
    <img
      v-show="loading"
      class="gif"
      src="../../assets/img/gif/logo-gif.gif"
      alt="Loading logo."
    />
  </span>
</template>
<style scoped>
.modal-active {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(208, 194, 245, 0.5);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gif {
  width: 50px;
}
</style>
